import { createClient } from "@supabase/supabase-js";

/* Config comes from Vite env vars (.env.local for dev, host env for prod).
   Keys are baked into the bundle at build time — that is fine and expected:
   the anon key is public by design, and RLS in Supabase is what protects data. */
const RAW_URL = import.meta.env.VITE_SUPABASE_URL || "";
const RAW_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

/* Normalise the URL: people paste it with a trailing slash, a doubled
   scheme, or the whole dashboard URL. Reduce to a bare origin. */
const URL_CLEAN = (() => {
  let u = RAW_URL.trim();
  if (!u) return u;
  u = u.replace(/^https?:\/\/\s*https?:\/\//i, "https://");
  if (!/^https?:\/\//i.test(u)) u = "https://" + u;
  try {
    u = new URL(u).origin;
  } catch {
    /* leave as-is; validated below */
  }
  return u;
})();

const KEY_CLEAN = RAW_KEY.trim();

const isConfigured = Boolean(URL_CLEAN && KEY_CLEAN);

let sb = null;
let sbInitError = null;

if (isConfigured) {
  try {
    if (!/^https:\/\/[a-z0-9-]+\.supabase\.co$/i.test(URL_CLEAN)) {
      throw new Error(
        'VITE_SUPABASE_URL looks off — it should be exactly https://your-ref.supabase.co ' +
          '(nothing after .supabase.co). Got: "' +
          URL_CLEAN +
          '"',
      );
    }
    sb = createClient(URL_CLEAN, KEY_CLEAN);
  } catch (e) {
    sbInitError = e.message || String(e);
  }
}

export { sb, isConfigured, sbInitError, URL_CLEAN, KEY_CLEAN };
